import PropTypes from 'prop-types';
import React, { memo } from 'react';
import './styles.scss';

const AuthTemplatePreview = memo(({ body, codeExpiration, buttons }) => {
  const renderOTPButton = (button) => {
    const buttonIcon = button.otp_type === 'COPY_CODE' ? 'fa-copy' : 'fa-check-circle';
    const buttonText = button.otp_type === 'COPY_CODE' ? 'Copy Code' : 'Verify Automatically';

    return (
      <button className="template-button auth-button" title={button.otp_type}>
        <i className={`fas ${buttonIcon}`}></i>
        {buttonText}
      </button>
    );
  };

  const parseVariables = (text) => {
    if (!text) return text;
    return text.replace(/\{\{\d+\}\}/g, (match) => {
      return <span className="variable-placeholder">{match}</span>;
    });
  };

  return (
    <div className="wa-template-preview auth-template">
      <div className="card border-0">
        <div className="card-header bg-light border-0 d-flex align-items-center">
          <i className="fas fa-lock-alt me-2"></i>
          <h5 className="mb-0">Authentication Template Preview</h5>
        </div>
        <div className="card-body">
          <div className="message-container">
            <div className="message-bubble">
              <div className="message-content">
                {body ? (
                  body.split('\n').map((text, index) => (
                    <p key={index} className="body-text">
                      {parseVariables(text)}
                    </p>
                  ))
                ) : (
                  <p className="body-text empty-body">No message content</p>
                )}

                <p className="footer auth-footer">
                  Your code will expire in {codeExpiration || 5} minutes
                </p>

                <div className="timestamp">
                  {new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  })}
                </div>
              </div>

              {buttons?.length > 0 && (
                <div className="button-container">
                  {buttons.map((button, index) => (
                    <React.Fragment key={index}>
                      {renderOTPButton(button)}
                      {button.otp_type === 'ONE_TAP' && button.supported_apps?.length > 0 && (
                        <div className="supported-apps">
                          <small>Supported Apps:</small>
                          {button.supported_apps.map((app, idx) => (
                            <small key={idx} className="app-name">
                              {app.package_name}
                            </small>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

AuthTemplatePreview.propTypes = {
  body: PropTypes.string,
  codeExpiration: PropTypes.number,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      otp_type: PropTypes.oneOf(['COPY_CODE', 'ONE_TAP']).isRequired,
      supported_apps: PropTypes.arrayOf(
        PropTypes.shape({
          package_name: PropTypes.string.isRequired,
          signature_hash: PropTypes.string.isRequired,
        })
      ),
    })
  ),
};

AuthTemplatePreview.displayName = 'AuthTemplatePreview';

export default AuthTemplatePreview;
